import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Link } from 'core/index';

import { Date } from 'apps/components/date';
import { media } from 'legacyComponents/styled/styleUtils';

import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

import { PublishedBy } from 'apps/story/views/publishedBy';

import { withNamespaces, Trans } from 'react-i18next';

export const StoryInfo = withNamespaces()(
  observer(({ story }) => {
    const {
      creatorProfile,
      spacePath,
      readLength,
      dateCreated,
      lastUpdated,
      slug,
      canUpdate,
      canDelete,
      Delete,
    } = story;

    let spaceType = 'profile';
    if (spacePath[0] === '+') {
      spaceType = 'initiative';
    }
    return (
      <Info>
        <PublishedBy
          spaceType={spaceType}
          spacePath={spacePath}
          creatorProfile={creatorProfile}
        />
        {' | '}
        <Date value={dateCreated} />
        <span>
          {' | '}
          <Trans count={readLength}>{{ readLength }} min read</Trans>
        </span>
        {dateCreated === lastUpdated
          ? ''
          : [' (', <Trans key='text'>Edited</Trans>, ')']}
        {canUpdate ? (
          <span>
            {' | '}
            <EditButton
              name={`${spaceType}.story.edit`}
              params={{ [spaceType]: spacePath, slug }}
            >
              <Trans>Edit</Trans>
            </EditButton>
          </span>
        ) : (
          ''
        )}
        {canDelete ? (
          <span>
            &nbsp;|&nbsp;
            <DeleteButton
              onClick={() =>
                modalStore.SetModalComponent(ConfirmAction, {
                  callBack: Delete,
                  title: 'delete this Story?',
                  undo: false,
                })
              }
            >
              <Trans>Delete</Trans>
            </DeleteButton>
          </span>
        ) : (
          ''
        )}
      </Info>
    );
  }),
);

const Info = styled.p`
  margin: 0px;
  font-size: 0.9375em;
  line-height: 1.4;
  ${media.s`
    font-size: 0.8em;
  `};
`;

const EditButton = styled(Link)`
  color: ${props => props.theme.color.wfGrey900};
  text-decoration: underline;
  &:hover {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
`;

const DeleteButton = styled.span`
  color: ${props => props.theme.color.wfGrey900};
  text-decoration: underline;
  &:hover {
    color: ${props => props.theme.color.wfOrange};
    cursor: pointer;
  }
`;

StoryInfo.propTypes = {
  story: PropTypes.object,
  t: PropTypes.func,
};
